import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {WebsitesComponent} from "./websites/websites.component";
import {WebsiteComponent} from "./websites/website/website.component";
import {PluginsComponent} from "./websites/website/plugins/plugins.component";
import {ThemesComponent} from "./websites/website/themes/themes.component";
import {AccountComponent} from "./account/account.component";
import {LoginComponent} from "./auth/login/login.component";
import {LoginForgotComponent} from "./auth/login-forgot/login-forgot.component";
import {UserRoles} from "./user/user-roles";
import {RouteWrapperComponent} from "./shared/components/route-wrapper/route-wrapper.component";
import {WebsiteResolver} from "./websites/website/website-resolver";
import {ResetPasswordComponent} from "./auth/reset-password/reset-password.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {UserStateGuard} from "./user/user-state.guard";
import {AuthGuard} from "./auth/auth.guard";
import {WebsiteGuard} from "./websites/website/website.guard";
import {AddWebsiteComponent} from "./add-website/add-website.component";
import {SequenceGuard} from "./shared/guards/sequence.guard";
import {SetupOnboardingRedirectGuard} from "./auth/setup-onboarding-redirect.guard";
import {SeoComponent} from "./websites/website/seo/seo.component";
import {UserResolver} from './user/user-resolver';
import {CompanyInfoResolver} from './shared/resolvers/company-info.resolver';
import {PluginsResolver} from './websites/website/plugins/plugins-resolver';
import {ThemesResolver} from './websites/website/themes/themes-resolver';
import {PaymentsResolver} from './workspace/billing/payments-resolver';
import {UserPaymentMethodResolver} from './workspace/subscription-plan/user-payment-method-resolver';
import {ManagerPluginResolver} from './websites/website/manager-plugin-resolver';
import {SeoPluginResolver} from './websites/website/seo-plugin-resolver';
import {EmailPreferencesComponent} from './account/email-preferences/email-preferences.component';
import {EmailPreferencesResolver} from './account/email-preferences/email-preferences-resolver';
import {UpgradePlanComponent} from "./workspace/upgrade-plan/upgrade-plan.component";
import {UserSubscriptionsResolver} from './workspace/upgrade-plan/user-subscriptions-resolver';
import {UserSubscriptionResolver} from './workspace/subscription-plan/user-subscription-resolver';
import {SubscriptionUpgradeAvailableGuard} from "./workspace/upgrade-plan/subscription-upgrade-available.guard";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {PaymentMethodsResolver} from './workspace/billing/payment-methods-resolver';
import {AvailableSubscriptionsResolver} from "./user/available-subscriptions-resolver";
import {OverviewComponent} from './websites/website/overview/overview.component';
import {HostingInfoComponent} from "./websites/website/hosting/info/hosting-info.component";
import {HostingComponent} from "./websites/website/hosting/hosting.component";
import {HostingInfoResolver} from "./websites/website/hosting/info/hosting-info-resolver";
import {OverviewOrderingResolver} from "./websites/website/overview/overview-ordering-resolver";
import {HostingDomainsComponent} from "./websites/website/hosting/domains/hosting-domains.component";
import {HostingDomainsResolver} from "./websites/website/hosting/domains/hosting-domains-resolver";
import {
  HostingDomainsManageAllComponent
} from "./websites/website/hosting/manage-all-domains/hosting-domains-manage-all.component";
import {HostingToolsComponent} from "./websites/website/hosting/tools/hosting-tools.component";
import {
  HostingDomainsManageDNSComponent
} from "./websites/website/hosting/manage-dns/hosting-domains-manage-dns.component";
import {HostingRedirectsComponent} from "./websites/website/hosting/redirects/hosting-redirects.component";
import {HostingRedirectsResolver} from "./websites/website/hosting/redirects/hosting-redirects-resolver";
import {HostingLogsComponent} from "./websites/website/hosting/logs/hosting-logs.component";
import {SecurityComponent} from './websites/website/security/security.component';
import {SecurityScanResolver} from './websites/website/security/security-scan-resolver';
import {SecurityPluginResolver} from './websites/website/security-plugin-resolver';
import {SecurityIgnoredIssuesResolver} from './websites/website/security/security-ignored-issues-resolver';
import {
  HostingResourceUsageComponent
} from "./websites/website/hosting/resource-usage/hosting-resource-usage.component";
import {ChangeEnvironmentComponent} from './websites/website/change-environment/change-environment.component';
import {
  HostingResourceVisitorsResolver
} from "./websites/website/hosting/resource-usage/hosting-resource-visitors-resolver";
import {
  HostingVisitsByWebsiteByDateResolver
} from "./websites/website/hosting/resource-usage/hosting-visits-by-website-by-date-resolver";
import {
  HostingDomainsManageDnsResolver
} from "./websites/website/hosting/manage-dns/hosting-domains-manage-dns-resolver";
import {
  HostingDomainsManageAllResolver
} from "./websites/website/hosting/manage-all-domains/hosting-domains-manage-all-resolver";
import {UserHostingSubscriptionsResolver} from './workspace/upgrade-plan/user-hosting-subscriptions-resolver';
import {SignUpComponent} from "./auth/sign-up/sign-up.component";
import {SignUpGuard} from './auth/sign-up.guard';
import {PaymentSubscriptionGuard} from './shared/guards/payment-subscription.guard';
import {
  HostingManageEnvironmentComponent
} from './websites/website/hosting/manage-environment/hosting-manage-environment.component';
import {ElementorPluginResolver} from "./websites/website/builder-templates/elementor-plugin-resolver";
import {BuilderPluginResolver} from "./websites/website/builder-templates/builder-plugin-resolver";
import {LastImportedTemplateResolver} from "./websites/website/builder-templates/last-imported-template-resolver";
import {PaypalWaitingComponent} from "./paypal-waiting/paypal-waiting.component";
import {GhostWaitingComponent} from "./ghost-waiting/ghost-waiting.component";
import {UserHostingServicesGuard} from "./user/user-hosting-services.guard";
import {SignUpTrialGuard} from "./auth/sign-up-trial.guard";
import {SignUpTrialComponent} from "./auth/sign-up-trial/sign-up-trial.component";
import {MoveTo10WebComponent} from "./websites/website/move-to-10web/moveTo10Web.component";
import {MySitesComponent} from "./websites/website/my-sites/mySites.component";
import {WhiteLabelComponent} from "./account/white-label/white-label.component";
import {AdvancedToolsComponent} from "./websites/website/advanced-tools/advancedTools.component";
import {BuilderSignoutComponent} from "./auth/builder-signout/builder-signout.component";
import {BuilderSignoutGuard} from "./auth/builder-signout.guard";
import {MobileDisclaimerComponent} from "./mobile-disclaimer/mobile-disclaimer.component";
import {UserManagementComponent} from "./user-managment/user-management.component";
import {WorkspaceComponent} from "./workspace/workspace.component";
import {HostingToolsResolver} from "./websites/website/hosting/tools/hosting-tools-resolver";
import {MigrationStepsComponent} from "./shared/components/migration-steps/migration-steps.component";
import {AddWebsiteResolver} from "./add-website/add-website.resolver";
import {WorkspaceGuard} from "./shared/guards/workspace.guard";
import {clientRoles} from "./user/user-roles-actions";
import {UserManagementResolver} from "./user-managment/user-management.resolver";
import {BillingInfoResolver} from "./workspace/billing-details/billing-info-resolver";
import {UserLocalStorageResolver} from "./user/user-local-storage.resolver";
import {WebsiteSettingsResolver} from "./websites/website/website-settings-resolver";
import {TenWebXComponent} from "./websites/website/tenWebX/tenWebX.component";
import {SetupComponent} from "./components/pages/setup/setup.component";
import {OtherStepComponent} from "./components/pages/setup/other/other.component";
import {CreateComponent} from "./components/pages/setup/create/create.component";
import {CreateOptionsComponent} from "./components/pages/setup/create/options/create-options.component";
import {StartBoosterComponent} from "./components/pages/setup/start-booster/start-booster.component";
import {ActivityLogComponent} from "./account/activity-log/activity-log.component";
import {ActivityLogResolver} from "./account/activity-log/activity-log.resolver";
import {ActivityLogDeletedClientsResolver} from "./account/activity-log/activity-log-deleted-clients.resolver";
import {ActivityLogDeletedDomainsResolver} from "./account/activity-log/activity-log-deleted-domains.resolver";
import {SomethingWentWrongComponent} from "./something-went-wrong/something-went-wrong.component";
import {FrontEndComponent} from "./websites/website/booster/front-end/front-end.component";
import {BackEndComponent} from "./websites/website/booster/back-end/back-end.component";
import {BoosterComponent} from "./websites/website/booster/booster.component";
import {
  BoosterDisconnectedComponent
} from "./websites/website/booster/booster-disconnected/booster-disconnected.component";
import {ImageOptimizerComponent} from "./websites/website/image-optimizer/image-optimizer.component";
import {MigrateOnlyComponent} from "./add-website/migrate-only/migrate-only.component";
import {AiBuilderComponent} from "./websites/website/ai-builder/ai-builder.component";
import {AdvancedSettingsComponent} from "./websites/website/booster/advanced/advanced-settings.component";
import {PluginConnectGuard} from "./shared/guards/plugin-connect.guard";
import {WebsitesGuard} from "./websites/websites.guard";
import {SetupGuard} from "./components/pages/setup/setup.guard";
import {
  BoosterImageOptimizerComponent
} from "./websites/website/booster/booster-image-optimizer/booster-image-optimizer.component";
import {SettingsComponent} from "./websites/website/booster/settings/settings.component";
import {CustomRulesComponent} from "./websites/website/booster/front-end/custom-rules/custom-rules.component";
import {CDNComponent} from "./websites/website/booster/cdn/cdn.component";
import {BoosterTroubleshootResolver} from "./websites/website/booster/boosterTroubleshootResolver";
import {RootGuard} from "./shared/guards/root.guard";
import {
  CreateAiBuilderComponent
} from "./components/pages/setup/create-ai/create-ai-builder/create-ai-builder.component";
import {
  CreateAiAssistantComponent
} from "./components/pages/setup/create-ai/create-ai-assistant/create-ai-assistant.component";
import {BoosterProTempComponent} from "./websites/website/booster/booster-pro/booster-pro-temp.component";
import {CompanyTypeResolver} from "./components/pages/setup/create-ai/company-type.resolver";
import {
  StartAiWebsiteBuildingComponent
} from "./components/pages/start-ai-website-building/start-ai-website-building.component";
import {BoosterWhiteLabelComponent} from "./websites/website/booster/white-label/white-label.component";
import {AccountDeletedComponent} from "./account-deleted/account-deleted.component";
import {EcommerceComponent} from "./websites/website/ecommerce/ecommerce.component";
import {WoocommercePluginResolver} from "./websites/website/woocommerce-plugin-resolver";
import {ProductsComponent} from "./websites/website/ecommerce/products/products.component";
import {AddProductComponent} from "./websites/website/ecommerce/products/add-product/add-product.component";
import {OrdersComponent} from "./websites/website/ecommerce/orders/orders.component";
import {OrderViewComponent} from "./websites/website/ecommerce/orders/order-view/order-view.component";
import {CustomersComponent} from "./websites/website/ecommerce/customers/customers.component";
import {CustomerViewComponent} from "./websites/website/ecommerce/customers/customer-view/customer-view.component";
import {ProductsListComponent} from "./websites/website/ecommerce/products/products-list/products-list.component";
import {OrdersListComponent} from "./websites/website/ecommerce/orders/orders-list/orders-list.component";
import {CustomersListComponent} from "./websites/website/ecommerce/customers/customers-list/customers-list.component";
import {EcommerceSettingsComponent} from "./websites/website/ecommerce/ecommerce-settings/ecommerce-settings.component";
import {EcommerceMenuComponent} from "./websites/website/ecommerce/ecommerce-menu/ecommerce-menu.component";
import {
  AddEcommerceMenuComponent
} from "./websites/website/ecommerce/ecommerce-menu/add-ecommerce-menu/add-ecommerce-menu.component";
import {
  NavigationMenuComponent
} from "./websites/website/ecommerce/ecommerce-menu/navigation-menu/navigation-menu.component";
import {SmoochAlternativeComponent} from "./smooch-alternative/smooch-alternative.component";
import {OutlineHandlerComponent} from "./outline-handler/outline-handler.component";
import {
  HostingDomainsListComponent
} from "./websites/website/hosting/domains/hosting-domains-list/hosting-domains-list.component";
import {EcommercePaymentMethodsComponent} from "./websites/website/ecommerce/payment-methods/payment-methods.component";
import {WorkspaceResolver} from "./user/workspace-resolver";
import {EcommerceOverviewComponent} from "./websites/website/ecommerce/ecommerce-overview/ecommerce-overview.component";
import {EcommerceTaxComponent} from "./websites/website/ecommerce/ecommerce-tax/ecommerce-tax.component";
import {EcommerceEmailsComponent} from "./websites/website/ecommerce/ecommerce-emails/ecommerce-emails.component";
import {PaymentManagementComponent} from "./websites/website/ecommerce/payment-management/payment-management.component";
import {
  SinglePagePayoutComponent
} from "./websites/website/ecommerce/payment-management/single-page-payout/single-page-payout.component";
import {WoocommerceTaxPluginResolver} from "./websites/website/ecommerce/ecommerce-tax/woocommerce-tax-plugin-resolver";
import {
  CreateCompanyInfoComponent
} from "./builder-v2/components/outline-generation/components/create-company-info/create-company-info.component";
import {
  MobileSignUpEmailComponent
} from "./builder-v2/components/outline-generation/components/mobile-sign-up-email/mobile-sign-up-email.component";
import {
  MobileSignUpComponent
} from "./builder-v2/components/outline-generation/components/mobile-sign-up/mobile-sign-up.component";
import {
  CreateProductCategoriesComponent
} from "./builder-v2/components/outline-generation/components/create-product-categories/create-product-categories.component";
import {SinglePageDemoGuard} from "./single-page-demo/singlePageDemo.guard";
import {
  PrefilledCompanyInfoComponent
} from "./builder-v2/components/outline-generation/components/prefilled-company-info/prefilled-company-info.component";
import {CustomDomainComponent} from "./components/pages/10web-API/components/custom-domain/custom-domain.component";
import {
  WpAdminWhiteLabelComponent
} from "./components/pages/10web-API/components/wp-admin-white-label/wp-admin-white-label.component";
import {
  PreInstalledPluginsComponent
} from "./components/pages/10web-API/components/pre-installed-plugins/pre-installed-plugins.component";
import {CheckoutResellerComponent} from "./auth/checkout/checkout-reseller/checkout-reseller.component";

export const routes: Routes = [
  {
    path: '',
    component: WebsitesComponent,
    canActivate: [RootGuard],
    resolve: {
      companyInfo: CompanyInfoResolver
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [SequenceGuard],
    resolve: {
      companyInfo: CompanyInfoResolver
    },
    data: {
      title: 'Login',
      pageId: 'login',
      roles: [UserRoles.guest],
      hasMainSidebar: false,
      hasMainHeader: false,

      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [AuthGuard, PluginConnectGuard]
    }
  },
  {
    path: 'forgot-password',
    component: LoginForgotComponent,
    canActivate: [SequenceGuard],
    resolve: {
      companyInfo: CompanyInfoResolver
    },
    data: {
      title: 'Forgot password',
      pageId: 'forgot-password',
      roles: [UserRoles.guest],
      hasMainSidebar: false,
      hasMainHeader: false,

      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [AuthGuard]
    }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [SequenceGuard],
    resolve: {
      companyInfo: CompanyInfoResolver
    },
    data: {
      title: 'Reset Password',
      pageId: 'reset-password',
      roles: [UserRoles.guest, UserRoles.user],
      hasMainSidebar: false,
      hasMainHeader: false,

      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [AuthGuard]
    }
  },
  {
    path: 'checkout',
    component: CheckoutResellerComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      payments: PaymentsResolver,
      userSubscription: UserSubscriptionResolver,
      availableSubscriptions: AvailableSubscriptionsResolver,
      companyInfo: CompanyInfoResolver
    },
    data: {
      title: 'Secure Checkout',
      pageId: 'checkout',
      roles: [UserRoles.guest, UserRoles.user],
      workspaceRoles: [clientRoles.OWNER, clientRoles.COMPANY_ADMIN, clientRoles.SUITE_DEV],
      hasMainSidebar: false,
      hasMainHeader: false,
      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [PaymentSubscriptionGuard, AuthGuard, WorkspaceGuard]
    }
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    canActivate: [SequenceGuard],
    resolve: {
      companyInfo: CompanyInfoResolver
    },
    data: {
      title: 'Sign Up',
      pageId: 'sign-up',
      roles: [UserRoles.guest],
      hasMainSidebar: false,
      hasMainHeader: false,
      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [PaymentSubscriptionGuard, SignUpGuard, PluginConnectGuard]
    }
  },
  {
    path: 'email-preferences/:userToken',
    component: EmailPreferencesComponent,
    canActivate: [SequenceGuard],
    resolve: {
      emailPreferences: EmailPreferencesResolver
    },
    data: {
      title: 'Email Preferences',
      pageId: 'email-preferences',
      hasMainSidebar: false,
      hasMainHeader: false,



      hasNotificationsBanner: false,
      hasSecondarySidebar: false
    }
  },
  {
    path: 'websites',
    component: WebsitesComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      userSubscription: UserSubscriptionResolver,
      availableSubscriptions: AvailableSubscriptionsResolver,
      companyInfo: CompanyInfoResolver
    },
    runGuardsAndResolvers: 'always',
    data: {
      title: 'Websites',
      pageId: 'websites',
      mainSidebarAutoCollapse: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [AuthGuard, UserStateGuard, WebsitesGuard, PluginConnectGuard]
    }
  },
  {
    path: 'websites/:id',
    component: WebsiteComponent,
    canActivate: [SequenceGuard],
    resolve: {
      website: WebsiteResolver,
      websiteSettings: WebsiteSettingsResolver,
      user: UserResolver,
      userLocalStorage: UserLocalStorageResolver,
      userSubscription: UserSubscriptionResolver
    },
    data: {
      title: 'Website',
      pageId: 'website',
      dynamicTitle: 'website.title',
      hasSecondarySidebar: true,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [AuthGuard, UserStateGuard, WebsiteGuard]
    },
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full'
      },
      {
        path: 'generate-page',
        loadChildren: () => import('./builder-v2/builder-v2.module').then(m => m.BuilderV2Module),
        canActivate: [SequenceGuard],
        resolve: {},
        runGuardsAndResolvers: 'always',
        data: {
          title: 'Generate Page',
          pageId: 'generate-page',
          hasMainSidebar: false,
          hasMainHeader: false,

          hasNotificationsBanner: false,
          hasSecondarySidebar: false,


          isSinglePage: true,
          guards: [AuthGuard, UserStateGuard, WebsitesGuard, PluginConnectGuard]
        }
      },
      {
        path: 'change-environment',
        component: RouteWrapperComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Change Environment',
          pageId: 'change-environment',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            redirectTo: 'live',
            pathMatch: 'full'
          },
          {
            path: 'live',
            component: ChangeEnvironmentComponent,
            canActivate: [SequenceGuard],
            resolve: {},
            data: {
              title: 'Change Environment',
              pageId: 'change-environment-live',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
            }
          },
          {
            path: 'dev',
            component: ChangeEnvironmentComponent,
            canActivate: [SequenceGuard],
            resolve: {},
            data: {
              title: '',
              pageId: 'change-environment-dev',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true
            }
          },
          {
            path: 'network',
            component: ChangeEnvironmentComponent,
            canActivate: [SequenceGuard],
            resolve: {},
            data: {
              title: '',
              pageId: 'change-environment-dev',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true
            }
          }
        ]
      },
      {
        path: 'move-to-10web',
        component: MoveTo10WebComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Check your score',
          pageId: 'move-to-10web',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      {
        path: 'pageSpeed',
        component: MoveTo10WebComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Check your score',
          pageId: 'pageSpeed',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      {
        path: 'my-sites',
        component: MySitesComponent,
        canActivate: [SequenceGuard],
        resolve: {
          user: UserResolver,
          userSubscription: UserSubscriptionResolver
        },
        data: {
          title: 'Network: My Sites',
          pageId: 'my-sites',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      {
        path: 'main',
        component: OverviewComponent,
        canActivate: [SequenceGuard],
        resolve: {
          overviewWidgetsOrdering: OverviewOrderingResolver,
          /* hostingUsageByWebsiteData: HostingResourceUsageByWebsiteResolver,
           hostingVisitorsByWebsiteData: HostingVisitsByWebsiteByDateResolver,
           hostingVisitorsData: HostingResourceVisitorsResolver,*/
          /*plugins: PluginsResolver*/
        },
        data: {
          title: 'Overview',
          pageId: 'main',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      /*{
        path: 'builder-trial',
        component: RecreateWebsiteComponent,
        canActivate: [SequenceGuard],
        resolve: {
          builderPlugin: BuilderPluginResolver,
          elementorPlugin: ElementorPluginResolver,
          lastImportedTemplate: LastImportedTemplateResolver
        },
        data: {
          title: '10Web Theme & Sites',
          pageId: 'builder-trial',
          hasSecondarySidebar : false,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },*/
      {
        path: 'ai-builder',
        component: AiBuilderComponent,
        canActivate: [SequenceGuard],
        resolve: {
          builderPlugin: BuilderPluginResolver,
          elementorPlugin: ElementorPluginResolver,
          lastImportedTemplate: LastImportedTemplateResolver,
          companyTypes: CompanyTypeResolver,
        },
        data: {
          title: 'AI Builder',
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          pageId: 'ai-builder'
        },
      },
      {
        path: 'outline-handler',
        component: OutlineHandlerComponent,
        canActivate: [SequenceGuard],
        resolve: {
          user: UserResolver,
        },
        data: {
          title: 'Smooch alternative',
          pageId: 'smooch-alt',
          hasSecondarySidebar: false,
          hasNotificationsBanner: false,
          hasMainSidebar: false,
          hasMainHeader: false,



          guards: [AuthGuard]
        }
      },
      /*{
        path: 'builder',
        component: BuilderTemplatesComponent,
        canActivate: [SequenceGuard],
        resolve: {
          builderPlugin: BuilderPluginResolver,
          elementorPlugin: ElementorPluginResolver,
          lastImportedTemplate: LastImportedTemplateResolver
        },
        data: {
          title: '10Web Theme & Sites',
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          pageId: 'builder'
        },
        children: [
          {
            path: '',
            redirectTo: 'recreate-website', //
            pathMatch: 'full'
          },
          {
            path: 'templates',
            component: TemplatesComponent,
            canActivate: [SequenceGuard],
            resolve: {

            },
            data: {
              title: 'Templates',
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              pageId: 'templates'
            },
          },
          {
            path: 'recreate-website',
            component: RecreateWebsiteComponent,
            canActivate: [SequenceGuard],
            resolve: {
            },
            data: {
              title: 'Recreate With AI',
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              pageId: 'recreate-website'
            },
          },
        ]
      },*/
      {
        path: 'ecommerce',
        component: EcommerceComponent,
        canActivate: [SequenceGuard],
        resolve: {
          woocommercePlugin: WoocommercePluginResolver,
        },
        data: {
          title: 'Ecommerce',
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          pageId: 'ecommerce'
        },
      },
      {
        path: 'plugins',
        component: RouteWrapperComponent,
        canActivate: [SequenceGuard],
        resolve: {
          subscription: UserSubscriptionResolver,
          subscriptions: UserSubscriptionsResolver
        },
        data: {
          title: 'Plugins',
          pageId: 'plugins',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            redirectTo: 'installed',
            pathMatch: 'full'
          },
          {
            path: 'installed',
            component: PluginsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              plugins: PluginsResolver
            },
            data: {
              title: 'Installed Plugins',
              pageId: 'installed-plugins',
              reloadAfterActionsComplete: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
            }
          },
          {
            path: 'available',
            component: PluginsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              plugins: PluginsResolver
            },
            data: {
              title: 'Available Plugins',
              pageId: 'available-plugins',
              reloadAfterActionsComplete: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              topbarButton: {
                label: 'Back To Installed',
                relativeUrl: 'installed'
              }
            }
          },
        ]
      },
      {
        path: 'themes',
        component: RouteWrapperComponent,
        canActivate: [SequenceGuard],
        resolve: {
          subscription: UserSubscriptionResolver,
          subscriptions: UserSubscriptionsResolver
        },
        data: {
          title: 'Themes',
          pageId: 'themes',
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            redirectTo: 'installed',
            pathMatch: 'full'
          },
          {
            path: 'installed',
            component: ThemesComponent,
            canActivate: [SequenceGuard],
            resolve: {
              themes: ThemesResolver
            },
            data: {
              title: 'Themes',
              pageId: 'installed-add-ons',
              reloadAfterActionsComplete: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              topbarButton: {
                label: 'Add Themes',
                relativeUrl: 'available'
              }
            }
          },
          {
            path: 'available',
            component: ThemesComponent,
            canActivate: [SequenceGuard],
            resolve: {
              themes: ThemesResolver
            },
            data: {
              title: 'Available Themes',
              pageId: 'available-add-ons',
              reloadAfterActionsComplete: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              topbarButton: {
                label: 'Back To Installed',
                relativeUrl: 'installed'
              }
            }
          },
        ]
      },
      {
        path: 'backup',
        loadChildren: () => import('./websites/website/backup/backup.module').then(m => m.BackupModule),
        canActivate: [SequenceGuard],
        data: {
          title: 'Backups',
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          pageId: 'backup'
        },
        resolve: {
          /*backupDataLimit: BackupDataLimitResolver,*/
          subscription: UserSubscriptionResolver,
          subscriptions: UserSubscriptionsResolver
        },
      },
      {
        path: 'image-optimizer',
        component: ImageOptimizerComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Image Optimizer',
          pageId: 'image-optimizer',
          boosterPage: true,
          hasTopBar: true,
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        }
      },
      {
        path: 'navigation',
        component: EcommerceMenuComponent,
        canActivate: [SequenceGuard],
        resolve: {
          subscription: UserSubscriptionResolver,
          user: UserResolver,
        },
        data: {
          title: 'Ecommerce Navigation',
          pageId: 'navigation',
          boosterPage: true,
          hasTopBar: true,
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            component: NavigationMenuComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Ecommerce menu',
              pageId: 'navigation',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'add-menu',
            component: AddEcommerceMenuComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Add Ecommerce menu',
              pageId: 'add-menu',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'edit-menu/:menuId',
            component: AddEcommerceMenuComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Edit Ecommerce menu',
              pageId: 'edit-menu',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
        ]
      },
      {
        path: 'ecommerce',
        component: EcommerceComponent,
        canActivate: [SequenceGuard],
        resolve: {
          woocommercePlugin: WoocommercePluginResolver,
        },
        data: {
          title: 'Ecommerce',
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          pageId: 'ecommerce'
        },
        children: [
          {
            path: 'products',
            component: ProductsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Products',
              pageId: 'products',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            children: [
              {
                path: '',
                component: ProductsListComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Add Ecommerce Products',
                  pageId: 'products-list',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'add-product',
                component: AddProductComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Add Ecommerce Products',
                  pageId: 'add-product',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'edit-product/:productId',
                component: AddProductComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Edit Ecommerce Product',
                  pageId: 'edit-product',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
            ]
          },
          {
            path: 'orders',
            component: OrdersComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Orders',
              pageId: 'orders',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            children: [
              {
                path: '',
                component: OrdersListComponent,
                canActivate: [SequenceGuard],
                resolve: {
                  subscription: UserSubscriptionResolver,
                  user: UserResolver,
                },
                data: {
                  title: 'Ecommerce Order view',
                  pageId: 'orders-list',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'order-view/:orderId',
                component: OrderViewComponent,
                canActivate: [SequenceGuard],
                resolve: {
                  subscription: UserSubscriptionResolver,
                  user: UserResolver,
                },
                data: {
                  title: 'Ecommerce Order view',
                  pageId: 'order-view',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
            ]
          },
          {
            path: 'customers',
            component: CustomersComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce customer list',
              pageId: 'customers',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            children: [
              {
                path: '',
                component: CustomersListComponent,
                canActivate: [SequenceGuard],
                resolve: {
                  subscription: UserSubscriptionResolver,
                  user: UserResolver,
                },
                data: {
                  title: 'Ecommerce customer view',
                  pageId: 'customers-list',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'customer-view/:customerId',
                component: CustomerViewComponent,
                canActivate: [SequenceGuard],
                resolve: {
                  subscription: UserSubscriptionResolver,
                  user: UserResolver,
                },
                data: {
                  title: 'Ecommerce customer view',
                  pageId: 'customer-view',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
            ]
          },
          {
            path: 'payment-methods',
            component: EcommercePaymentMethodsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce payment method',
              pageId: 'payment-methods',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'navigation',
            component: EcommerceMenuComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Navigation',
              pageId: 'navigation',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            children: [
              {
                path: '',
                component: NavigationMenuComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Ecommerce menu',
                  pageId: 'navigation',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'add-menu',
                component: AddEcommerceMenuComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Add Ecommerce menu',
                  pageId: 'add-menu',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
              {
                path: 'edit-menu/:menuId',
                component: AddEcommerceMenuComponent,
                canActivate: [SequenceGuard],
                data: {
                  title: 'Edit Ecommerce menu',
                  pageId: 'edit-menu',
                  boosterPage: true,
                  hasTopBar: true,
                  hasSecondarySidebar: true,
                  hasHostingOfferBanner: true,
                  hasTrialForInvitedBanner: true,
                  guards: [AuthGuard, UserStateGuard]
                }
              },
            ]
          },
          {
            path: 'settings',
            component: EcommerceSettingsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Settings',
              pageId: 'ecommerce-settings',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'overview',
            component: EcommerceOverviewComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Overview',
              pageId: 'overview',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'tax',
            component: EcommerceTaxComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              taxPlugin: WoocommerceTaxPluginResolver
            },
            data: {
              title: 'Ecommerce Tax',
              pageId: 'tax',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'emails',
            component: EcommerceEmailsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Ecommerce Emails',
              pageId: 'emails',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
        ]
      },
      {
        path: 'booster',
        component: BoosterComponent,
        canActivate: [SequenceGuard],
        resolve: {
          subscription: UserSubscriptionResolver,
          user: UserResolver,
        },
        data: {
          title: '10Web Website Booster',
          pageId: 'booster',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: 'disabled',
            component: BoosterDisconnectedComponent,
            canActivate: [SequenceGuard],
            data: {
              title: '10Web Website Booster',
              pageId: 'boosterDisconnected',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
          },
          {
            path: 'frontend',
            component: FrontEndComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
            data: {
              title: 'Website Booster: Main page',
              pageId: 'frontend',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'pages',
            component: CustomRulesComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
            data: {
              title: 'Website Booster: Pages',
              pageId: 'pages',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'image-optimizer',
            component: BoosterImageOptimizerComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
            data: {
              title: 'Website Booster: Image Optimizer',
              pageId: 'booster-image-optimizer',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          /*{
            path: 'cloudflare',
            component: CDNComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
            },
            data: {
              title: 'Website Booster: Cloudflare CDN',
              pageId: 'cloudflare',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },*/
          {
            path: 'hosting-performance',
            component: BackEndComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Website Booster: Hosting performance',
              pageId: 'hosting-performance',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            resolve: {
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
          },
          {
            path: 'settings',
            component: SettingsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
            data: {
              title: 'Website Booster: Settings',
              pageId: 'settings',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'white-label',
            component: BoosterWhiteLabelComponent,
            canActivate: [SequenceGuard],
            resolve: {
              subscription: UserSubscriptionResolver,
              user: UserResolver,
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
            data: {
              title: 'Website Booster: White label',
              pageId: 'white-label',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'pro',
            component: BoosterProTempComponent,
            canActivate: [SequenceGuard],
            data: {
              title: '10Web Website Booster Pro',
              pageId: 'booster-pro',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: false,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard, SubscriptionUpgradeAvailableGuard]
            }
          },
          {
            path: 'advanced',
            component: AdvancedSettingsComponent,
            canActivate: [SequenceGuard],
            data: {
              title: '10Web Website Booster: Advanced Settings',
              pageId: 'advanced',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            resolve: {
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
          },
          {
            path: 'cdn',
            component: CDNComponent,
            canActivate: [SequenceGuard],
            data: {
              title: '10Web Website Booster: CDN',
              pageId: 'cdn',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
        ]
      },
      {
        path: 'seo',
        component: SeoComponent,
        canActivate: [SequenceGuard],
        resolve: {
          seoPlugin: SeoPluginResolver
        },
        data: {
          title: 'SEO',
          pageId: 'seo',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      {
        path: 'security',
        component: SecurityComponent,
        canActivate: [SequenceGuard],
        resolve: {
          subscription: UserSubscriptionResolver,
          subscriptions: UserSubscriptionsResolver,
          securityPlugin: SecurityPluginResolver,
          securityScan: SecurityScanResolver,
          securityIgnoredIssues: SecurityIgnoredIssuesResolver
        },
        data: {
          title: 'Security',
          pageId: 'security',
          hasTopBar: true,
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        }
      },
      /* {
         path: 'performance',
         component: PerformanceComponent,
         canActivate: [SequenceGuard],
         data: {
           title: 'Performance',
           pageId: 'performance',
           hasTopBar: true,
           hasSecondarySidebar : true,
           hasHostingOfferBanner: true,
 hasTrialForInvitedBanner: true,
           guards: [AuthGuard, UserStateGuard]
         },
         children: [
           {
             path: '',
             redirectTo: 'history',
             pathMatch: 'full'
           },
           {
             path: 'history',
             component: PerformanceHistoryComponent,
             canActivate: [SequenceGuard],
             resolve: {
               performanceHistory: PerformanceHistoryResolver
             },
             data: {
               title: 'Performance Check',
               pageId: 'performance-history',
               hasTopBar: true,
               hasSecondarySidebar : true,
               hasHostingOfferBanner: true,
 hasTrialForInvitedBanner: true,
               guards: [AuthGuard, UserStateGuard]
             }
           },
           {
             path: 'test/:id',
             component: PerformanceTestComponent,
             canActivate: [SequenceGuard],
             resolve: {
               performanceTest: PerformanceTestResolver
             },
             data: {
               title: 'Performance check',
               description: 'hhhh',
               pageId: 'performance-test',
               hasTopBar: true,
               hasSecondarySidebar : true,
               hasHostingOfferBanner: true,
 hasTrialForInvitedBanner: true,
               guards: [AuthGuard, UserStateGuard],
               topbarButton: {
                 linkLabel: 'Performance check',
                 relativeUrl: '/../performance-history'
               }
             }
           }
         ]
       },*/
      {
        path: 'domains',
        component: HostingDomainsComponent,
        canActivate: [SequenceGuard],
        resolve: {
          hostingInfoData: HostingDomainsResolver,
          payments: PaymentsResolver
        },
        data: {
          title: 'Domains',
          pageId: 'domains',
          hasTopBar: true,
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            component: HostingDomainsListComponent,
            canActivate: [SequenceGuard],
            pathMatch: 'full',
            data: {
              title: 'Domains',
              pageId: 'domains',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'domains-manage-dns/:zId',
            component: HostingDomainsManageDNSComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingZoneData: HostingDomainsManageDnsResolver
            },
            data: {
              title: 'Domains: Manage DNS',
              pageId: 'hosting-domains-manage-dns',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
        ]
      },
      {
        path: 'hosting',
        component: HostingComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Hosting',
          pageId: 'hosting',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            redirectTo: 'info',
            pathMatch: 'full'
          },
          {
            path: 'info',
            component: HostingInfoComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingInfoData: HostingInfoResolver
            },
            data: {
              title: 'Hosting: Credentials',
              pageId: 'hosting-info',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'tools',
            component: HostingToolsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingSettingsData: HostingToolsResolver
            },
            data: {
              title: 'Hosting: Tools',
              pageId: 'hosting-tools',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'redirects',
            component: HostingRedirectsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingInfoData: HostingRedirectsResolver
            },
            data: {
              title: 'Hosting: URL Redirects',
              pageId: 'redirects',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'manage-environment',
            component: HostingManageEnvironmentComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingInfoData: HostingInfoResolver
            },
            data: {
              title: 'Manage Environment',
              pageId: 'manage-environment',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'logs',
            component: HostingLogsComponent,
            canActivate: [SequenceGuard],
            /*resolve: {
              hostingInfoData: HostingLogsResolver
            },*/
            data: {
              title: 'Hosting: Logs',
              pageId: 'logs',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'environment',
            component: HostingManageEnvironmentComponent,
            canActivate: [SequenceGuard],
            resolve: {
              user: UserResolver,
              subscription: UserSubscriptionResolver
            },
            data: {
              title: 'Staging Environment',
              pageId: 'environment',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'cdn',
            component: HostingDomainsComponent,
            canActivate: [SequenceGuard],
            resolve: {
              hostingInfoData: HostingDomainsResolver
            },
            data: {
              pageId: 'cdn',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'resource-usage',
            component: HostingResourceUsageComponent,
            canActivate: [SequenceGuard],
            resolve: {
              // hostingUsageData: HostingResourceUsageResolver,
              hostingVisitsByWebsiteByDate: HostingVisitsByWebsiteByDateResolver,
              hostingVisitorsData: HostingResourceVisitorsResolver,
              // hostingUsageByWebsiteData: HostingResourceUsageByWebsiteResolver
            },
            data: {
              title: 'Hosting: Resource Usage',
              pageId: 'hosting-resource-usage',
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            }
          },
          {
            path: 'advanced-tools',
            component: AdvancedToolsComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Advanced Tools',
              pageId: 'advanced-tools',
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
          },
          {
            path: 'hosting-performance',
            component: BackEndComponent,
            canActivate: [SequenceGuard],
            data: {
              title: 'Website Booster: Hosting performance',
              pageId: 'hosting-performance:',
              boosterPage: true,
              hasTopBar: true,
              hasSecondarySidebar: true,
              hasHostingOfferBanner: true,
              hasTrialForInvitedBanner: true,
              guards: [AuthGuard, UserStateGuard]
            },
            resolve: {
              boosterTroubleshootData: BoosterTroubleshootResolver
            },
          },
        ]
      },
      {
        path: 'tenWebX',
        component: TenWebXComponent,
        canActivate: [SequenceGuard],
        resolve: {
          builderPlugin: BuilderPluginResolver,
          elementorPlugin: ElementorPluginResolver
        },
        data: {
          title: 'TenWebX',
          pageId: 'tenWebX',
          hasSecondarySidebar: true,
          hasHostingOfferBanner: true,
          hasTrialForInvitedBanner: true,
          guards: [AuthGuard, UserStateGuard]
        },
      },
      /*{
        path: 'onboarding',
        component: OnboardingComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Start Onboarding',
          pageId: 'onboarding',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          guards: [AuthGuard, UserStateGuard]
        },
        children: [
          {
            path: '',
            redirectTo: 'onboarding',
            pathMatch: 'full',
            data: {
              title: 'Start Onboarding',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'onboarding'
            },
          },
          {
            path: 'onboarding-templates',
            component: TemplatesComponent,
            canActivate: [SequenceGuard],
            resolve: {

            },
            data: {
              title: 'Templates',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'onboarding-templates'
            },
          },
          {
            path: 'onboarding-recreate-website',
            component: RecreateWebsiteComponent,
            canActivate: [SequenceGuard],
            resolve: {
            },
            data: {
              title: 'Recreate With AI',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'onboarding-recreate-website'
            },
          },
        ]
      },*/
    ]
  },
  {
    path: 'activity-log',
    component: ActivityLogComponent,
    canActivate: [SequenceGuard],
    resolve: {
      subscription: UserSubscriptionResolver,
      activities: ActivityLogResolver,
      deletedClients: ActivityLogDeletedClientsResolver,
      deletedDomains: ActivityLogDeletedDomainsResolver,
      workspace: UserManagementResolver,
      user: UserResolver
    },
    data: {
      title: 'Activity Log',
      pageId: 'activity-log',
      hasTopBar: true,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [UserStateGuard]
    }
  },
  {
    path: 'paypal-waiting',
    component: PaypalWaitingComponent,
    canActivate: [SequenceGuard],
    resolve: {
      subscription: UserSubscriptionResolver,
    },
    data: {
      title: 'Paypal Waiting',
      pageId: 'paypal-waiting',
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [UserStateGuard]
    }
  },
  {
    path: 'ghost-waiting',
    component: GhostWaitingComponent,
    canActivate: [SequenceGuard],
    resolve: {
      subscription: UserSubscriptionResolver
    },
    data: {
      title: 'Ghost Waiting',
      pageId: 'ghost-waiting',
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [UserStateGuard]
    }
  },
  {
    path: 'add-website',
    component: AddWebsiteComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      managerPlugin: ManagerPluginResolver,
      subscription: UserSubscriptionResolver,
      addWebsiteResolver: AddWebsiteResolver
    },
    data: {
      title: 'Add Website',
      pageId: 'add-website',
      workspaceRoles: [clientRoles.OWNER, clientRoles.COMPANY_ADMIN, clientRoles.COMPANY_DEV],
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      hasMainSidebar: true,
      guards: [AuthGuard, UserStateGuard, PluginConnectGuard]
    }
  },
 {
    path: 'setup-onboarding',
    component: SetupComponent,
    canActivate: [SetupOnboardingRedirectGuard, SequenceGuard],
    data: {
      title: 'Start Setup',
      roles: [UserRoles.guest],
      pageId: 'setup-onboarding',
      hasSecondarySidebar: false,
      hasMainSidebar: false,
      hasMainHeader: false,
      guards: [AuthGuard]
    },
    children: [
      {
        path: '',
        redirectTo: 'setup-onboarding',
        pathMatch: 'full',
        data: {
          title: 'Start Setup',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'setup-onboarding'
        },
      },
      /*{
        path: 'domain-search',
        component: PublicDomainSearchComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Start AI Website Building',
          pageId: 'domain-search',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false,
          hasMainAiHeader: false,



          hasNotificationsBanner: false,
          hasSecondarySidebar: false,
          guards: [AuthGuard]
        }
      },*/
      {
        path: 'start-ai-website-building',
        component: StartAiWebsiteBuildingComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Start AI Website Building',
          pageId: 'start-ai-website-building',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false,
          hasMainAiHeader: false,



          hasNotificationsBanner: false,
          hasSecondarySidebar: false,
          guards: [AuthGuard, WorkspaceGuard]
        }
      },
      {
        path: 'v2-ai-website-building',
        loadChildren: () => import('./builder-v2/builder-v2.module').then(m => m.BuilderV2Module),
        canActivate: [SequenceGuard],
        runGuardsAndResolvers: 'always',
        data: {
          title: 'Start AI website building',
          pageId: 'v2-ai-website-building',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false,

          hasNotificationsBanner: false,
          hasSecondarySidebar: false,


        }
      },
      {
        path: 'fill-company-info',
        component: CreateCompanyInfoComponent,  // Mobile-specific component for V2
        canActivate: [SequenceGuard],
        data: {
          title: 'Fill company info',
          pageId: 'fill-company-info',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false
        }
      },
      {
        path: 'filled-company-info',
        component: PrefilledCompanyInfoComponent,  // Mobile-specific component for V2
        canActivate: [SequenceGuard],
        data: {
          title: 'Filled company info',
          pageId: 'filled-company-info',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false
        }
      },
      {
        path: 'fill-products',
        component: CreateProductCategoriesComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Fill products',
          pageId: 'fill-products',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false
        }
      },
      {
        path: 'mobile-sign-up',
        component: MobileSignUpComponent,
        canActivate: [SequenceGuard],
        runGuardsAndResolvers: 'always',
        data: {
          title: 'Sign up',
          pageId: 'mobile-sign-up',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false,

          hasNotificationsBanner: false,
          hasSecondarySidebar: false,


        }
      },
      {
        path: 'mobile-sign-up-email',
        component: MobileSignUpEmailComponent,
        canActivate: [SequenceGuard],
        runGuardsAndResolvers: 'always',
        data: {
          title: 'Sign up: Email',
          pageId: 'mobile-sign-up-email',
          roles: [UserRoles.guest],
          hasMainSidebar: false,
          hasMainHeader: false,

          hasNotificationsBanner: false,
          hasSecondarySidebar: false,


        }
      },
    ]
  },
  {
    path: 'setup',
    component: SetupComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      currentSubscription: UserSubscriptionResolver,
      addWebsiteResolver: AddWebsiteResolver
    },
    data: {
      title: 'Start Setup',
      pageId: 'setup',
      hasSecondarySidebar: false,
      hasMainSidebar: false,
      hasMainHeader: false,
      guards: [AuthGuard, UserStateGuard, SetupGuard, PluginConnectGuard]
    },
    children: [
      {
        path: '',
        redirectTo: 'setup',
        pathMatch: 'full',
        data: {
          title: 'Start Setup',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'setup'
        },
      },
      {
        path: 'change-hosting',
        component: MigrateOnlyComponent,
        canActivate: [SequenceGuard],
        resolve: {
          user: UserResolver
        },
        data: {
          title: 'Move to 10Web',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'move-hosting'
        },
        /*children: [
          {
            path: 'change-hosting',
            component: ChangeHostingComponent,
            canActivate: [SequenceGuard],
            resolve: {

            },
            data: {
              title: 'Change My Hosting',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'change-hosting'
            },
          },
          {
            path: 'convert-wp',
            component: RecreateAiComponent,
            canActivate: [SequenceGuard],
            resolve: {

            },
            data: {
              title: 'Convert to WordPress',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'convert-wp'
            },
          },
        ]*/
      },
      {
        path: 'optimize',
        component: StartBoosterComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Get a 90+ PageSpeed Score',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'optimize'
        },
        children: [
          {
            path: 'start-booster',
            component: StartBoosterComponent,
            canActivate: [SequenceGuard],
            resolve: {},
            data: {
              title: 'Get 10Web Booster',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'start-booster'
            },
          },
        ]
      },
      {
        path: 'ai-demo',
        component: CreateAiAssistantComponent,
        canActivate: [SequenceGuard],
        resolve: {
          companyTypes: CompanyTypeResolver,
        },
        data: {
          title: 'Create With AI Assistant',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'ai-demo'
        },
      },
      {
        path: 'ai-convert',
        component: CreateAiBuilderComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Convert With AI Builder',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'convert'
        },
      },
      {
        path: 'install-blank',
        component: CreateOptionsComponent,
        canActivate: [SequenceGuard],
        data: {
          title: 'Use your own theme & plugins',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'install-blank'
        },
      },
      {
        path: 'create',
        component: CreateComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Create',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'create'
        },
        children: [
          {
            path: ':id',
            component: CreateOptionsComponent,
            canActivate: [SequenceGuard],
            resolve: {},
            data: {
              title: 'Create Options',
              hasSecondarySidebar: false,
              hasMainSidebar: false,
              hasMainHeader: false,
              pageId: 'options'
            },
          }
        ]
      },
      {
        path: 'other',
        component: OtherStepComponent,
        canActivate: [SequenceGuard],
        resolve: {},
        data: {
          title: 'Other',
          hasSecondarySidebar: false,
          hasMainSidebar: false,
          hasMainHeader: false,
          pageId: 'other'
        },
      },
      {
        path: 'builder-v2',
        loadChildren: () => import('./builder-v2/builder-v2.module').then(m => m.BuilderV2Module),
        canActivate: [SequenceGuard],
        runGuardsAndResolvers: 'always',
        data: {
          title: 'Create With AI Assistant ',
          pageId: 'builder-v2',
          hasMainSidebar: false,
          hasMainHeader: false,

          hasNotificationsBanner: false,
          hasSecondarySidebar: false,


        }
      },
    ]
  },
  {
    path: 'migration-steps',
    component: MigrationStepsComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver
    },
    data: {
      title: 'Migration Steps',
      pageId: 'migration-steps',
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      hasMainSidebar: false,
      guards: [AuthGuard, UserStateGuard, WorkspaceGuard]
    }
  },
  {
    path: 'domains-manage-all',
    component: HostingDomainsManageAllComponent,
    canActivate: [SequenceGuard],
    resolve: {
      hostingZonesData: HostingDomainsManageAllResolver
    },
    data: {
      title: 'Manage DNS',
      pageId: 'hosting-domains-manage-all',
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,
      guards: [AuthGuard, UserStateGuard, UserHostingServicesGuard]
    }
  },
  {
    path: 'domains-manage-dns/:zId',
    component: HostingDomainsManageDNSComponent,
    canActivate: [SequenceGuard],
    resolve: {
      hostingZoneData: HostingDomainsManageDnsResolver
    },
    data: {
      title: 'Manage DNS',
      external: true,
      pageId: 'hosting-domains-manage-dns',
      hasTopBar: false,
      hasSecondarySidebar: false,
      hasHostingOfferBanner: true,
      hasTrialForInvitedBanner: true,

      guards: [AuthGuard, UserStateGuard]
    }
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
    },
    data: {
      title: 'Contact us',
      pageId: 'contact-us',
      mainSidebarAutoCollapse: false,
      hasSecondarySidebar: false,
      guards: [AuthGuard]
    }
  },
  {
    path: 'account/:tabId',
    component: AccountComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      userSubscription: UserSubscriptionResolver
    },
    data: {
      title: 'Account',
      pageId: 'account',
      hasSecondarySidebar: false,
      hasHostingOfferBanner: false,
      hasTrialForInvitedBanner: false,
      hasNotificationsBanner: false,



      guards: [AuthGuard]
    }
  },
  {
    path: 'workspace/:tabId',
    component: WorkspaceComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      billingInfo: BillingInfoResolver,
      userSubscription: UserSubscriptionResolver,
      userPaymentMethod: UserPaymentMethodResolver,
      payments: PaymentsResolver
    },
    data: {
      title: 'Workspace',
      pageId: 'workspace',
      workspaceRoles: [clientRoles.OWNER, clientRoles.COMPANY_ADMIN, clientRoles.SUITE_DEV],
      hasSecondarySidebar: false,
      hasHostingOfferBanner: false,
      hasTrialForInvitedBanner: false,
      hasNotificationsBanner: false,
      guards: [AuthGuard, WorkspaceGuard, UserStateGuard]
    }
  },
  {
    path: "upgrade",
    redirectTo: "upgrade-plan"
  },
  {
    path: 'upgrade-plan',
    component: UpgradePlanComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      subscription: UserSubscriptionResolver,
      availableSubscriptions: AvailableSubscriptionsResolver,
      paymentMethods: PaymentMethodsResolver,
    },
    data: {
      title: 'Upgrade Plan',
      pageId: 'upgrade-plan',
      hasSecondarySidebar: false,
      hasHostingOfferBanner: false,
      hasTrialForInvitedBanner: false,
      guards: [AuthGuard]
    }
  },
  {
    path: '404',
    component: PageNotFoundComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Page not found',
      pageId: 'page-not-found',
      hasSecondarySidebar: false,
      hasNotificationsBanner: false,
      hasMainSidebar: false,
      hasMainHeader: false,



    }
  },
  {
    path: 'something-went-wrong',
    component: SomethingWentWrongComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Something went wrong',
      pageId: 'something-went-wrong',
      hasSecondarySidebar: false,
      hasNotificationsBanner: false,
      hasMainSidebar: false,
      hasMainHeader: false,



    }
  },
  {
    path: 'white-label',
    component: WhiteLabelComponent,
    canActivate: [SequenceGuard],
    resolve: {
      userSubscription: UserSubscriptionResolver
    },
    data: {
      title: 'White label',
      pageId: 'white-label',
      workspaceRoles: [clientRoles.OWNER, clientRoles.COMPANY_ADMIN],
      hasSecondarySidebar: false,
      hasNotificationsBanner: true,
      hasMainSidebar: true,
      hasMainHeader: true,
      guards: [WorkspaceGuard]
    },
    children: [
      {
        path: '',
        redirectTo: 'wp-admin-white-label',
        pathMatch: 'full'
      },
      {
        path: 'custom-domain',
        component: CustomDomainComponent,
        data: {
          title: 'Custom Domain',
          pageId: 'custom-domain',
          hasMainSidebar: true,
          hasMainHeader: true,
          hasAppsumoHeaderBanner: false,
          hasNotificationsBanner: true,
          hasSecondarySidebar: false,
          hasAiBuilderHeaderBanner: false,
          hasAiBuilderHostingHeaderBanner: false,
        }
      },
      {
        path: 'wp-admin-white-label',
        component: WpAdminWhiteLabelComponent,
        data: {
          title: 'WP Admin White Label',
          pageId: 'wp-admin-white-label',
          hasMainSidebar: true,
          hasMainHeader: true,
          hasAppsumoHeaderBanner: false,
          hasNotificationsBanner: true,
          hasSecondarySidebar: false,
          hasAiBuilderHeaderBanner: false,
          hasAiBuilderHostingHeaderBanner: false,
        }
      },
      {
        path: 'pre-installed-plugins',
        component: PreInstalledPluginsComponent,
        data: {
          title: 'Pre-installed Plugins',
          pageId: 'pre-installed-plugins',
          hasMainSidebar: true,
          hasMainHeader: true,
          hasAppsumoHeaderBanner: false,
          hasNotificationsBanner: true,
          hasSecondarySidebar: false,
          hasAiBuilderHeaderBanner: false,
          hasAiBuilderHostingHeaderBanner: false,
        }
      }
    ]
  },
  {
    path: 'sign-up-trial',
    component: SignUpTrialComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Sign Up',
      pageId: 'sign-up',
      roles: [UserRoles.guest],
      hasMainSidebar: false,
      hasMainHeader: false,



      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [SignUpTrialGuard]
    }
  },
  {
    path: 'builder-signout',
    component: BuilderSignoutComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Sign Out',
      pageId: 'builder-signout',
      hasMainSidebar: false,
      hasMainHeader: false,



      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [BuilderSignoutGuard]
    }
  },
  {
    path: 'mobile-disclaimer',
    component: MobileDisclaimerComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Mobile Disclaimer',
      pageId: 'mobile-disclaimer',
      hasMainSidebar: false,
      hasMainHeader: false,



      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      roles: [UserRoles.user],
      guards: [AuthGuard, UserStateGuard]
    }
  },
  {
    path: 'user-management',
    component: UserManagementComponent,
    canActivate: [SequenceGuard],
    resolve: {
      workspace: UserManagementResolver
    },
    data: {
      title: 'User & Team Management',
      pageId: 'user-management',
      workspaceRoles: [clientRoles.OWNER],
      hasSecondarySidebar: false,
      guards: [AuthGuard, UserStateGuard, WorkspaceGuard]
    },
  },
  {
    path: 'account-deleted',
    component: AccountDeletedComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Account Deleted',
      pageId: 'account-deleted',
      hasSecondarySidebar: false,
      hasNotificationsBanner: false,
      hasMainSidebar: false,
      hasMainHeader: false,



      guards: [AuthGuard]
    }
  },
  {
    path: 'message-sandbox',
    component: SmoochAlternativeComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
    },
    data: {
      title: 'Smooch alternative',
      pageId: 'smooch-alt',
      hasSecondarySidebar: false,
      hasNotificationsBanner: false,
      hasMainSidebar: false,
      hasMainHeader: false,



      guards: [AuthGuard]
    }
  },
  {
    path: 'payments-management',
    component: PaymentManagementComponent,
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver,
      currentWorkspace: WorkspaceResolver
    },
    data: {
      title: 'Payment Management',
      pageId: 'payments-management',
      hasSecondarySidebar: false,
      hasNotificationsBanner: false,
      hasMainSidebar: true,
      hasMainHeader: true,



      guards: [AuthGuard],
    },
    children: [
      {
        path: ':id/payouts',
        component: SinglePagePayoutComponent,
        canActivate: [SequenceGuard],
        resolve: {
          user: UserResolver,
          currentWorkspace: WorkspaceResolver
        },
        data: {
          title: 'Domain Payouts',
          hasSecondarySidebar: false,
          hasNotificationsBanner: false,
          hasMainSidebar: true,
          hasMainHeader: true,



          pageId: 'domain-payouts'
        },
      }
    ]
  },
  {
    path: 'single-page-demo',
    loadChildren: () => import('./single-page-demo/single-page-demo.module').then(m => m.SinglePageDemoModule),
    canActivate: [SequenceGuard],
    resolve: {
      user: UserResolver
    },
    data: {
      title: 'Single Page Demo',
      pageId: 'single-page-demo',
      hasMainSidebar: false,
      hasMainHeader: false,

      hasNotificationsBanner: false,
      hasSecondarySidebar: false,
      guards: [AuthGuard, UserStateGuard, SinglePageDemoGuard]
    }
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [SequenceGuard],
    data: {
      title: 'Page not found',
      pageId: 'page-not-found',
      hasSecondarySidebar: false,
      hasMainSidebar: false,
      hasNotificationsBanner: false,
      hasMainHeader: false,
    }
  }
];

// TODO ASK ABOUT onSameUrlNavigation and recheck
@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
